<template>
  <div class="contenedor fila-selector">
    <!-- Categoria -->
    <div :class="'mb-3 d-inline-block ' + claseSelects">
      <div class="form-floating">
        <select
          @change="seleccionarCategoria($event)"
          v-model="idCat"
          :required="required"
          v-bind="$attrs"
          class="form-select"
          id="floatingSelectCat"
          aria-label="Categoría"
        >
          <option v-bind:key="null" v-bind:value="null">Seleccionar</option>
          <option
            v-for="cat in categorias"
            v-bind:key="cat.id"
            v-bind:value="cat.id"
          >
            {{ cat.name }}
          </option>
        </select>
        <label for="floatingSelectCat">Categoría</label>
        <div class="invalid-feedback">Elija una categoría</div>
      </div>
    </div>

    <!--Sub categoria -->
    <div :class="'mb-3 d-inline-block ' + claseSelects">
      <div class="form-floating">
        <select
          @change="seleccionarSubCategoria($event)"
          v-model="idSub"
          :required="required"
          v-bind="$attrs"
          class="form-select"
          id="floatingSelectSub"
          aria-label="Sub Categoría"
        >
          <option v-bind:key="null" v-bind:value="null">Seleccionar</option>
          <option
            v-for="sub in subCategorias"
            v-bind:key="sub.id"
            v-bind:value="sub.id"
          >
            {{ sub.name }}
          </option>
        </select>
        <label for="floatingSelectCat">Sub Categoría</label>
        <div class="invalid-feedback">Elija una subcategoría</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Api } from "../../../api";

const EVENTO_SUBCATEGORIA_CAMBIADA = "subcategoria-cambiada";

export default {
  props: {
    // Clase que será aplicada a los selects
    claseSelects: String,
    idSubCategoria: {
      type: String,
      default: null,
    },
    permiteEditar: {
      type: Boolean,
      default: true,
    },
    /** En caso de ser verdadero se le aplicará el atributo 'required' a los selects */
    required: Boolean,
  },
  data() {
    return {
      categorias: [],
      idCat: null,
      /** Se usa esta para no mutar la prop */
      idSub: this.idSubCategoria,
      subCategorias: [],
    };
  },
  watch: {
    idSubCategoria(nueva) {
      if (this.idSub != nueva) {
        this.idSub = nueva;
        this.cargarSubcategoriasHermanas(nueva);
      }
    },
  },
  methods: {
    cargarCategorias() {
      Api.Categoria.getTodas().then((response) => {
        this.categorias = response.data;
      });
    },
    /** Carga la lista de subCategorias para la categoría seleccionada */
    cargarSubcategoriasDeCategoria(idCat) {
      if (idCat) {
        Api.Categoria.getSubcategoriasDeCategoria(idCat).then((respuesta) => {
          this.subCategorias = respuesta.data;
        });

        this.idCat = idCat;
      }
      // Poner en null porque puede venir como ""
      else {
        this.limpiarCategorias();
      }
    },
    /** Carga las demás subcategorías (hermanas) que pertenecen a la misma categoría (madre) de la subcategoría actual */
    cargarSubcategoriasHermanas(idSubCategoria) {
      if (idSubCategoria) {
        // Primero obtener categoría madre
        Api.Categoria.getCategoriaDeSubcategoria(idSubCategoria).then(
          (resp) => {
            this.cargarSubcategoriasDeCategoria(resp.data.id);
          }
        );
      }
      // Limpiar ya que no hay subcategoría
      else {
        this.limpiarCategorias();
      }
    },
    limpiarCategorias() {
      this.idCat = null;
      this.subCategorias = [];
    },
    seleccionarCategoria: async function (event) {
      this.cargarSubcategoriasDeCategoria(event.target.value);
      // Limpiar subcategoría
      this.subCategoriaSeleccionada(null);
    },
    seleccionarSubCategoria: async function (event) {
      this.subCategoriaSeleccionada(event.target.value);
    },
    subCategoriaSeleccionada(id) {
      this.idSub = id;
      this.$emit(EVENTO_SUBCATEGORIA_CAMBIADA, id);
    },
  },
  mounted() {
    this.cargarCategorias();
    if (this.idSub) {
      this.cargarSubcategoriasHermanas(this.idSub);
    }
  },
};
</script>
<style scoped>
.contenedor {
  display: contents;
}
</style>